/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Event_Client_CreatedInputs */

const cs_event_client_created = /** @type {(inputs: Event_Client_CreatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Klient vytvořen`)
};

const en_event_client_created = /** @type {(inputs: Event_Client_CreatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Client created`)
};

/**
* | output |
* | --- |
* | "Client created" |
*
* @param {Event_Client_CreatedInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const event_client_created = /** @type {((inputs?: Event_Client_CreatedInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Event_Client_CreatedInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_event_client_created(inputs)
	return cs_event_client_created(inputs)
});